<template>
  <base-alert v-if="show" class="text-center" type="danger">
    <div
      v-for="alert in alerts"
      :key="alert">
      <span v-html="alert"></span>
    </div>
  </base-alert>
</template>
<script>
import { BaseAlert } from '../../components';

export default {
  components: {
    BaseAlert
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },
    alerts: {
      type: Array,
      required: true,
      default: null
    }
  }
}
</script>
